var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bb"},[_c('img',{staticClass:"an1",attrs:{"src":require("@/assets/close0.png"),"alt":""}}),_c('img',{staticClass:"an2",attrs:{"src":require("@/assets/wind1.png"),"alt":""}})])
}]

export { render, staticRenderFns }